<template>
  <div class="tree-content">
    <el-tree
      ref="tree"
      :data="treeData"
      show-checkbox
      node-key="code"
      :check-strictly="true"
      :props="defaultProps"
      :check-on-click-node="true"
      :expand-on-click-node="false"
      :default-expand-all="true"
      @check-change="checkChange"
      :filter-node-method="filterNode"
      @check="checked"
      :default-checked-keys="checkedKeys"
    >
      <div slot-scope="{ node }" :style="node.level === 2 ? 'width: 70px' : ''">
        <span :class="'node_' + node.key">{{ node.label }}</span>
      </div>
    </el-tree>
    <!-- <div class="btn-space" v-if="isShowSave">
      <el-button class="con-btn" @click="consoleEdit"> 取消 </el-button>
      <el-button type="primary" @click="saveRolePermission"> 保存 </el-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "selectTree",
  props: {
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    checkedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    clickedRoleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    searchForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isCreatRole: {
      type: Boolean,
      default: false,
    },
    isShowSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedKey: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filteredTreeData: [],
      ftree: null,
      codes: [],
    };
  },
  watch: {
    checkedKeys(newval) {
      this.checkedKey = newval;
      this.updateCheckedKeys(newval);
    },
    deep: true,
  },
  mounted() {
    this.$nextTick(() => {
      this.expandNode();
    });
  },
  methods: {
    consoleEdit() {
      this.$emit("consoleEdit", false);
    },
    updateCheckedKeys(newCheckedKeys) {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(newCheckedKeys);
      });
    },
    saveRolePermission() {
      // console.log("this.searchForm", this.searchForm);
      let treeData = [...this.treeData];
      const checkedKeys = this.checkedKey;

      const markSelected = (items) => {
        for (let item of items) {
          item.selected = checkedKeys.includes(item.code);
          if (item.children) {
            markSelected(item.children);
          }
        }
      };

      markSelected(treeData);
      if (this.isCreatRole) {
        this.creatRole(treeData);
      } else {
        this.editRole(treeData);
      }
    },
    afterPost(res) {
      // console.log("res==", res.data);
      const data = res.data;
      if (data.code === 1000) {
        this.$message({
          type: "success",
          message: data.msg,
        });
      } else {
        this.$message({
          type: "error",
          message: data.msg,
        });
      }
    },
    expandNode() {
      const arr = [
        "merchant_detail",
        "device_detail",
        "project_detail",
        "after_sales_order",
        "feedbackDetail",
        "account_detail",
        "wait_to_handle",
      ];
      arr.forEach((k) => {
        const node = this.$refs.tree.$el.querySelector(".node_" + k);
        const nodep = node.parentElement.parentElement.parentElement;
        nodep.style.display = "block";
        nodep.children[1].style.display = "flex";
        nodep.children[1].style.paddingLeft = "20px";
      });
    },
    handleNodeClick(node) {
      // console.log("Clicked node:", node);
    },
    checkChange(node, checked) {
      // console.log("checkChange", node, checked);
      if (!checked) {
        this.removeCodes(node);
      }
    },
    removeCodes(node) {
      // 从 codes 数组中移除当前节点的 code
      if (this.codes.length === 0) return;
      const index = this.codes.indexOf(node.code);
      if (index !== -1) {
        this.codes.splice(index, 1);
      }

      // 如果有子节点，递归移除子节点的 code
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          this.removeCodes(child);
        });
      }
    },
    flatTree(tree) {
      let arr = [...(tree || [])];
      let nodes = [];
      while (arr.length) {
        let node = arr.shift();
        nodes.push({ ...node });
        arr.push(...(node.children || []).map((n) => ({ ...n, parent: node })));
      }
      return nodes;
    },
    extractCodes(nodes) {
      let codes = [];
      nodes.forEach((node) => {
        codes.push(node.code); // 提取当前节点的 code
        // if (node.children && node.children.length > 0) {
        //   // 如果有子节点，递归提取子节点的 code
        //   const childCodes = this.extractCodes(node.children);
        //   codes = codes.concat(childCodes);
        // }
      });

      return [...new Set(codes)];
    },
    checked(value, nodes) {
      let selected = nodes.checkedKeys.includes(value.code);
      this.ftree = this.ftree || this.flatTree(this.treeData);
      let ftree = this.ftree;
      let keys = [];
      let arr = [value];
      while (arr.length) {
        let node = arr.shift();
        keys.push(node.code);
        arr.push(...(node.children || []));
      }
      if (selected) {
        arr = ftree.filter((n) => n.code === value.code);
        while (arr.length) {
          let node = arr.shift();
          keys.push(node.code);
          if (node.parent) {
            arr.push(node.parent);
          }
        }
        console.log("keys==", keys);

        this.$refs.tree.setCheckedKeys([...nodes.checkedKeys, ...keys]);
        this.checkedKey = [];
        this.checkedKey = this.extractCodes(this.$refs.tree.getCheckedNodes());
        this.$emit("getCheckedKeys", this.checkedKey);
        // console.log("this.checkedKeys==", this.checkedKey);
      } else {
        const filteredKeys = nodes.checkedKeys.filter(
          (n) => !keys.some((k) => k === n)
        );
        this.$refs.tree.setCheckedKeys(filteredKeys); // 更新选中的 key
        this.checkedKey = filteredKeys;

        this.$emit("getCheckedKeys", this.checkedKey);
      }

      // console.log(111, value, nodes, selected, ftree);
    },
    filterNode(value, data) {
      console.log("filterNode", value, data);

      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="less" scoped>
.tree-content {
  width: 100%;
  padding-bottom: 70px;
}
::v-deep .el-tree-node__children {
  /* display: flex !important; */
}
/* ::v-deep .custom-container {
  display: flex !important;
} */
::v-deep .el-tree-node {
  .el-tree-node__content {
    height: auto;
    line-height: 26px;
    padding: 0 20px 0 12px !important;
    box-shadow: 5px 1px 30px #efefef;
    margin: 5px 0;
  }
  display: flex;
}
::v-deep .el-tree-node__expand-icon {
  display: none;
}
::v-deep .el-tree-node__expand-icon::before {
  display: none;
}
::v-deep .el-tree-node__content:hover {
  // background-color: transparent !important;
}
.btn-space {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 45px;
  position: sticky;
  .el-button {
    border-radius: 2px;
    font-size: 14px;
    width: 60px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
  }
  .con-btn {
    background-color: #f2f3f5;
    color: #4e5969;
  }
}
// .el-tree .is-checked .el-checkbox__input.is-checked .el-checkbox__inner {
//   background-color: #FF9800; /* 自定义选中的背景色 */
//   // border-color: #FF9800;     /* 自定义选中的边框色 */
// }
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #165dff;
  border-color: #165dff;
}
</style>